// ============================================
// P2 E-02：SSE 分块解析（纯函数，便于单测）
// 从流式缓冲区中提取完整的 event/data 块，返回剩余未完成缓冲
// ============================================

export interface SseBlock {
  event: string;
  data: string;
}

export function extractSseEvents(buf: string): { blocks: SseBlock[]; rest: string } {
  const blocks: SseBlock[] = [];
  let rest = buf;
  let idx: number;
  while ((idx = rest.indexOf('\n\n')) >= 0) {
    const raw = rest.slice(0, idx);
    rest = rest.slice(idx + 2);
    const event = /^event: (.+)$/m.exec(raw)?.[1];
    const data = /^data: (.+)$/m.exec(raw)?.[1];
    if (event && data) blocks.push({ event, data });
  }
  return { blocks, rest };
}
